import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { ChargeDetailConstant } from "./ChargeDetailConstant";

const CHARGE_DETAIL_CONSTANT = ChargeDetailConstant.Charge;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const CHARGE_DETAIL_AGENTDELIVERYDATE_COL_DEF: any[] = [
    {
        headerName: CHARGE_DETAIL_CONSTANT.CNTR_NO,
        field: "cntrNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: CHARGE_DETAIL_CONSTANT.AGENT_DELIVERY_DATE,
        field: "agentDeliveryDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date",
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}